import React, { useState } from 'react';
import cx from 'classnames';
import { Divider } from '../../reporting/sidebar/components';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import BarChartConfiguration from './BarChartConfiguration';
import PieChartConfiguration from './PieChartConfiguration';
import LineChartConfiguration from './LineChartConfiguration';
import ScatterPlotConfiguration from './ScatterPlotConfiguration';
import ScatterBubblePlotConfiguration from './ScatterBubblePlotConfiguration';

function chartSidebarForType(chartType) {
  const sidebarComponent = {
    BarChart: BarChartConfiguration,
    PieChart: PieChartConfiguration,
    LineChart: LineChartConfiguration,
    ScatterPlot: ScatterPlotConfiguration,
    ScatterBubblePlot: ScatterBubblePlotConfiguration,
  }[chartType];

  if (!sidebarComponent) {
    throw new Error(
      `Could not determine chart sidebar for chart type ${chartType}`
    );
  }

  return sidebarComponent;
}

function ConfigurationSidebar({
  meta,
  chartType,
  horizontalSortType,
  verticalSortType,
}) {
  const ChartConfigSidebar = chartSidebarForType(chartType);
  const [open, setIsOpen] = useState(true);
  const { undo, undoable, redo, redoable } = useReportConfiguration();

  return (
    <div
      id='configuration-sidebar'
      className={cx('custom-chart-sidebar', {
        'custom-chart-sidebar--closed': !open,
      })}
    >
      <div className='custom-chart-sidebar__top-section'>
        <span
          className='custom-chart-sidebar__top-header'
          onClick={() => setIsOpen(!open)}
        >
          <i
            className={cx('sidebar-toggle-icon fa-regular', {
              'fa-angles-right': open,
              'fa-angles-down': !open,
            })}
          />
          Configure chart
        </span>
        {open && (
          <>
            <div className='btn-group'>
              <button
                className={cx('btn history-btn', { disabled: !undoable })}
                onClick={() => undoable && undo()}
              >
                <i className='fa-solid fa-undo' />
              </button>
              <button
                className={cx('btn history-btn', { disabled: !redoable })}
                onClick={() => redoable && redo()}
              >
                <i className='fa-solid fa-redo' />
              </button>
            </div>
          </>
        )}
      </div>
      {open && <Divider />}
      <div className='custom-chart-sidebar__body'>
        <ChartConfigSidebar
          meta={meta}
          horizontalSortType={horizontalSortType}
          verticalSortType={verticalSortType}
        />
      </div>
    </div>
  );
}

export default ConfigurationSidebar;
